import script from "./PaymentsToVCFS.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentsToVCFS.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentsToVCFS.vue?vue&type=style&index=0&id=b7726ff2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7726ff2"]])

export default __exports__